import { render, staticRenderFns } from "./ProjectListItem.vue?vue&type=template&id=254b3e78&scoped=true"
import script from "./ProjectListItem.vue?vue&type=script&lang=js"
export * from "./ProjectListItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectListItem.vue?vue&type=style&index=0&id=254b3e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b3e78",
  null
  
)

export default component.exports